export default __webpack_public_path__ + "static/media/bg_testimonial_left.01f20d5a.svg";